<template>
  <div>
    <h1 class="header-style">
      Worker <br>
      Check-Out
    </h1>
    <br>
    <p class="subheader-style">
      Click <font class="next-text">
        'Next'
      </font> to complete the check-out.
    </p>
    <v-stepper
      v-if="isWorkTypeIssue"
      v-model="userCheckOut"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckOut > 1"
          step="1"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="userCheckOut > 2"
          step="2"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="userCheckOut > 3"
          color="#000"
          step="3"
        />
      </v-stepper-header>
    </v-stepper>
    <v-stepper
      v-if="!isWorkTypeIssue"
      v-model="userCheckOut"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckOut > 1"
          step="1"
          color="#000"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckOut > 2"
          step="2"
          color="#000"
        />
      </v-stepper-header>
    </v-stepper>
    <div>
      <worker-location-verification
        v-if="showLocationVerificationPage"
        :org-settings="orgSettings"
        @verification-completed="toSecondStep"
      />
      <review-work-checkout-details
        v-if="showWorkCheckoutPage"
        @checkout-completed="checkOutCompleted"
      />
      <gather-issue-status
        v-if="showIssueStatusPage"
        @issue-status-stored="toThirdStep"
      />
      <review-issue-checkout-details
        v-if="showIssueCheckoutPage"
        @checkout-completed="checkOutCompleted"
      />
    </div>
  </div>
</template>
<script>
  import WorkerLocationVerification from '../dialogComponents/WorkerDialogs/checkout/WorkerLocationVerification';
  import ReviewWorkCheckoutDetails from '../dialogComponents/WorkerDialogs/checkout/ReviewWorkCheckoutDetails.vue';
  import GatherIssueStatus from '../dialogComponents/WorkerDialogs/checkout/GatherIssueStatus.vue';
  import ReviewIssueCheckOutDetails from '../dialogComponents/WorkerDialogs/checkout/ReviewIssueCheckOutDetails.vue';
  export default {
    name: 'WorkerCheckOutPage',
    components: {
      'worker-location-verification': WorkerLocationVerification,
      'review-work-checkout-details': ReviewWorkCheckoutDetails,
      'gather-issue-status': GatherIssueStatus,
      'review-issue-checkout-details': ReviewIssueCheckOutDetails,
    },
    data () {
      return {
        userCheckOut: 1,
        showLocationVerificationPage: true,
        step1SuccessColor: '',
        showWorkCheckoutPage: false,
        showIssueStatusPage: false,
        showIssueCheckoutPage: false,
      };
    },
    computed: {
      step1Success () {
        return `color:${this.step1SuccessColor}`;
      },
      step2Success () {
        return `color:${this.step2SuccessColor}`;
      },
      activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      isActiveCheckInDetailsFetched () {
        if (Object.keys(this.activeCheckInDetails).length > 0) {
          return true;
        }
        return false;
      },
      checkOutMethodType () {
        return this.$store.getters['swiftuser/getCheckOutMethodType'];
      },
      isWorkTypeIssue () {
        if (this.isActiveCheckInDetailsFetched === true && this.activeCheckInDetails.work_details.type === 'project-issue') {
          return true;
        }
        return false;
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
      orgSettings () {
        return this.$store.getters['organization/getOrganizationSettings'];
      },
    },
    async mounted () {
      await this.fetchActiveCheckInDetails();
      this.fetchOrgDetails();
      this.loadOnMount();
    },
    methods: {
      async fetchOrgDetails () {
        await this.$store.dispatch('organization/fetchOrganizationSettings', this.activeCheckInDetails);
      },
      loadOnMount () {
        if (this.checkOutMethodType === null) {
          this.$router.push({ name: 'CheckOut' });
        }
      },
      async fetchActiveCheckInDetails () {
        this.loading = true;
        await this.$store.dispatch('swiftuser/fetchUsersCurrentCheckInDetails').then(response => {
          if (this.isActiveCheckInDetailsFetched === true) {
            this.loading = false;
            return;
          }
          this.loading = false;
          this.$router.push({ name: 'HomePage' });
        }).catch(() => {
          this.loading = false;
          this.$router.push({ name: 'HomePage' });
        });
      },
      toSecondStep () {
        this.step1SuccessColor = '#00796B';
        this.userCheckOut = 2;
        if (this.isWorkTypeIssue === false) {
          this.showLocationVerificationPage = false;
          this.showIssueCheckoutPage = false;
          this.showIssueStatusPage = false;
          this.showWorkCheckoutPage = true;
          return;
        }
        this.showLocationVerificationPage = false;
        this.showIssueCheckoutPage = false;
        this.showWorkCheckoutPage = false;
        this.showIssueStatusPage = true;
      },
      toThirdStep () {
        this.step2SuccessColor = '#00796B';
        this.userCheckOut = 3;
        this.showLocationVerificationPage = false;
        this.showIssueStatusPage = false;
        this.showWorkCheckoutPage = false;
        this.showIssueCheckoutPage = true;
      },
      checkOutCompleted () {
        this.$router.push({ name: 'HomePage' });
      },
    },
  };
</script>
